// ══════════════════════════════════════════════════════════════════
//  ED CRM - Constantes de status do lead (centralizadas)
// ══════════════════════════════════════════════════════════════════
//  Substitui as 3 cópias de STATUS_MAP que existiam em:
//    - src/components/LeadDetail.jsx
//    - src/components/LeadModal.jsx
//    - src/pages/LeadsPage.js
//
//  Divergência detectada na unificação: LeadModal usava #3B82F6 para
//  o status `new`; LeadDetail e LeadsPage usavam #2563C8 (blue do
//  design system). Padronizado em #2563C8 (var(--blue)).
//
//  Status: bate com o enum lead_status do banco (Config/07_schema).
// ══════════════════════════════════════════════════════════════════

export const LEAD_STATUS_KEYS = ['new', 'contacted', 'qualified', 'proposal', 'won', 'lost'] as const;

export type LeadStatus = typeof LEAD_STATUS_KEYS[number];

export interface LeadStatusInfo {
  label: string;
  color: string;
  bg: string;
}

export const LEAD_STATUS_MAP: Record<LeadStatus, LeadStatusInfo> = {
  new:        { label: 'Novo',        color: '#2563C8', bg: '#DBEAFE' },
  contacted:  { label: 'Contatado',   color: '#8B5CF6', bg: '#EDE9FE' },
  qualified:  { label: 'Qualificado', color: '#10B981', bg: '#D1FAE5' },
  proposal:   { label: 'Proposta',    color: '#F59E0B', bg: '#FEF3C7' },
  won:        { label: 'Ganho',       color: '#166534', bg: '#DCFCE7' },
  lost:       { label: 'Perdido',     color: '#DC2626', bg: '#FEE2E2' },
};

// Helper: retorna o objeto do status ou o de 'new' como fallback.
export const getLeadStatusInfo = (status: string | null | undefined): LeadStatusInfo =>
  (status && status in LEAD_STATUS_MAP
    ? LEAD_STATUS_MAP[status as LeadStatus]
    : LEAD_STATUS_MAP.new);
